var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTargetAchievement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4658_32469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7205 9.8613C15.7205 13.0974 13.0972 15.7207 9.86114 15.7207M15.7205 9.8613C15.7205 6.62524 13.0972 4.00192 9.86114 4.00192M15.7205 9.8613L19.2752 9.86132M9.86114 15.7207C6.62509 15.7207 4.00177 13.0974 4.00177 9.8613M9.86114 15.7207L9.86115 19.2754M4.00177 9.8613C4.00177 6.62524 6.62509 4.00192 9.86114 4.00192M4.00177 9.8613L0.447083 9.86132M9.86114 4.00192L9.86115 0.447266M9.84898 6.37116L10.9316 8.56483L13.3525 8.91659L11.6007 10.6241L12.0142 13.0351L9.84898 11.8968L7.6837 13.0351L8.09726 10.6241L6.34554 8.91659L8.76636 8.56483L9.84898 6.37116ZM18.0643 9.8613C18.0643 14.3918 14.3916 18.0644 9.86114 18.0644C5.33068 18.0644 1.65802 14.3918 1.65802 9.8613C1.65802 5.33083 5.33068 1.65817 9.86114 1.65817C14.3916 1.65817 18.0643 5.33083 18.0643 9.8613Z",
    stroke: "#706F7B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4658_32469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetAchievement);
export default __webpack_public_path__ + "static/media/targetAchievement.3bd62be15aa9739e8e633b0f9434478d.svg";
export { ForwardRef as ReactComponent };